import type { WorkspaceQueueDto, Attribute } from '@mark43/cad-api';
import { mapQueueClassesToAgencyTypeGlobalAttributes } from './map-queue-classes-to-agency-type-global-attributes';
import { toAttributeOption } from '../../attributes/to-attribute-option';

export const getAttributeOptionsForQueueType = (
    queueClasses: WorkspaceQueueDto['queueClasses'],
    attributes: Attribute[]
) => {
    const agencyTypeGlobalAttrIds = mapQueueClassesToAgencyTypeGlobalAttributes(queueClasses);
    return attributes
        .filter(
            (attr) =>
                !!attr.displayValue &&
                !!attr.parentAttributeId &&
                agencyTypeGlobalAttrIds.includes(attr.parentAttributeId)
        )
        .map((attr) => toAttributeOption(attr));
};
